// REDUCER
import * as actionTypes from '../constants/actions';

const defaultState = {
	profiles: [],
	single: {},
	isFetching: false,
};

function profilesReceived(state, payload) {
	state = setBusy(state, false);

	if (typeof payload === 'object' && payload.hasOwnProperty('profiles')) {
		return {...state, profiles: payload.profiles, prev: payload.prev, next: payload.next, total: payload.total, totalProfiles: payload.totalProfiles, meta: payload.meta};
	}

	if (typeof payload === 'object' && payload.hasOwnProperty('error')) {

		let error = payload;

		return {...state, profiles: error};
	}

	return state;
}

function singleProfileReceived(state, payload) {
	state = setBusy(state, false);

	if (typeof payload === 'object' && payload.hasOwnProperty('id')) {
		return {...state, single: payload};
	}

	return state;
}

function singleProfileCasesReceived(state, payload) {
	state = setBusy(state, false);

	if (typeof payload === 'object') {
		return {...state, cases: payload};
	}

	return state;
}

function setBusy(state, payload = true) {
	return {...state, isFetching: payload};
}

function reqSingleProfile(state, payload = true) {
	state = setBusy(state, true);

	return {...state};
}

function reqProfiles(state, payload = true) {
	state = setBusy(state, true);

	return {...state};
}

export default function menuReducer(state = defaultState, action) {
	switch (action.type) {
		case actionTypes.PROFILES_RECV_SINGLE_DATA:
			return singleProfileReceived(state, action.payload);
		case actionTypes.PROFILES_RECV_CASE_DATA:
			return singleProfileCasesReceived(state, action.payload);
		case actionTypes.PROFILES_REQ_SINGLE_DATA:
			return reqSingleProfile(state);
		case actionTypes.PROFILES_RECV_DATA:
			return profilesReceived(state, action.payload);
		case actionTypes.PROFILES_REQ_DATA:
			return reqProfiles(state);
		case actionTypes.PROFILES_CLEAR_DATA:
			return {...state, single: [], update: 0};
		default:
			return state;
	}
}



/** WEBPACK FOOTER **
 ** ./frontend/reducers/profiles.js
 **/